import * as Config from '../../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import MidDropBoxV2 from '../../dnd/MidDropBoxV2';

// Rows can be moved in a list to change the order.
function Sortable({ idParent, index, width, height, onDrop, afterSortable, containerRef = null }) {
  const styleMidDropBox = {
    backgroundColor : `transparent`, zIndex: 20, position: `absolute`,
    width: width, height: height / 2,
    opacity: 0,
  }
  return (
    <>
      <div id={`list-drop-top-${index}`} style={{ ...styleMidDropBox, top: 0, borderTop: `1px solid ${Config.BRAND_PRIMARY}` }} />
      <div id={`list-drop-bottom-${index}`} style={{ ...styleMidDropBox, bottom: 0, borderBottom: `1px solid ${Config.BRAND_PRIMARY}` }} />
      <>
        <MidDropBoxV2 active={(index === 0) ? `list-drop-top-${index}` : `list-drop-bottom-${index - 1}`} accept={[`TRACK`, `CHART`, `TRACK-CARD`, `DECK`]} containerRef={containerRef} containerRefLvl={4} drop={onDrop(idParent, index - 1, afterSortable)} style={{ ...styleMidDropBox, top: 0, borderTop: `1px solid ${Config.BRAND_PRIMARY}` }} />
        <MidDropBoxV2 active={`list-drop-bottom-${index}`} accept={[`TRACK`, `CHART`, `TRACK-CARD`, `DECK`]} containerRef={containerRef} containerRefLvl={4} drop={onDrop(idParent, index, afterSortable)} style={{ ...styleMidDropBox, bottom: 0, borderBottom: `1px solid ${Config.BRAND_PRIMARY}` }} />
      </>
    </>
  )
}

Sortable.propTypes = {
  idParent: PropTypes.any.isRequired,
  index: PropTypes.number.isRequired,
  width: PropTypes.any.isRequired,
  height: PropTypes.any.isRequired,
  onDrop: PropTypes.func.isRequired,
  afterSortable: PropTypes.func,
  containerRef: PropTypes.any
}

export default Sortable;
